import React from 'react';

import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import {IHotelData, IHotelDataType} from '../redux/types';
import SRPCardLoader from '../../../../stories/components/hotels/Loadingpage/SRPCardLoader/SRPCardLoader';
import SignUpBanner from '../../../../stories/components/hotels/SRP/SignUpBanner/SignUpBanner';
import SegmentSlider from '../../HomePage/containers/SegmentSlider';
import SmartEngageBanner from './SmartEngageBanner';

const options = {
  root: null,
  threshHold: 0.01,
};

const HotelListPlaceholder = ({
  shouldFetchMore,
  fetchMoreFn,
  showLastItemLoader,
  data,
  children,
  toggleSiginPopupCaller,
  error,
  applyFilterCta,
}: {
  shouldFetchMore: boolean;
  fetchMoreFn: any;
  showLastItemLoader: boolean;
  data: IHotelData & {type: IHotelDataType; hctx?: string};
  children: Element;
  toggleSiginPopupCaller: Function;
  error?: Boolean;
  applyFilterCta: Function;
}) => {
  let elRef = null;
  if (shouldFetchMore) {
    const [watcherRef] = useIntersectionObserver(options, () => {
      fetchMoreFn(true);
    });
    elRef = watcherRef;
  }

  const itemToRender = () => {
    const arr = [];

    // if (!error) {
    if (data.type === 'SignUpBanner')
      arr.push(<SignUpBanner actionHandler={toggleSiginPopupCaller} />);

    if (data.type === 'SegmentSlider') arr.push(<SegmentSlider hctxValue={data.hctx || ''} />);

    if (data.type === 'SmartEngageBanner')
      arr.push(<SmartEngageBanner applyFilterCta={applyFilterCta} />);
    // }

    arr.push(children);

    if (showLastItemLoader) arr.push(<SRPCardLoader />);

    // if (error)
    //   arr.push(
    //     <BannerCard text="Failed to fetch hotels. Please try reloading or resetting filters" />,
    //   );
    return arr;
  };

  return <div ref={elRef}>{itemToRender()}</div>;
};

export default React.memo(HotelListPlaceholder);
